import React, { useLayoutEffect } from "react";
import { KTUtil } from "../../_assets/js/components/util";
import KTLayoutAside from "../../_assets/js/layout/base/aside";
import KTLayoutAsideMenu from "../../_assets/js/layout/base/aside-menu";
import KTLayoutContent from "../../_assets/js/layout/base/content";
import KTLayoutFooter from "../../_assets/js/layout/base/footer";
import KTLayoutSubheader from "../../_assets/js/layout/base/subheader";
import KTLayoutScrolltop from "../../_assets/js/layout/extended/scrolltop";
import KTLayoutStickyCard from "../../_assets/js/layout/base/sticky-card";
import KTLayoutStretchedCard from "../../_assets/js/layout/base/stretched-card";
import KTLayoutQuickPanel from "../../_assets/js/layout/extended/quick-panel";
import KTLayoutQuickUser from "../../_assets/js/layout/extended/quick-user";
import KTLayoutHeaderMobile from "../../_assets/js/layout/base/header-mobile";
import KTLayoutAsideToggle from "../../_assets/js/layout/base/aside-toggle";
import KTLayoutQuickSearch from "../../_assets/js/layout/extended/quick-search";
import KTLayoutQuickNotifications from "../../_assets/js/layout/extended/quick-notifications";
import KTLayoutQuickActions from "../../_assets/js/layout/extended/quick-actions";

export function LayoutInit() {
  useLayoutEffect(() => {
    // برای اطمینان از اینکه DOM کاملاً مستقر شده، از یک تأخیر کوتاه استفاده می‌کنیم
    const timeoutId = setTimeout(() => {
      // مقداردهی اولیه بخش‌های اصلی
      if (typeof KTLayoutHeaderMobile !== "undefined") KTLayoutHeaderMobile.init("kt_header_mobile");
      if (typeof KTLayoutAside !== "undefined") KTLayoutAside.init("kt_aside");
      if (typeof KTLayoutAsideToggle !== "undefined") KTLayoutAsideToggle.init("kt_aside_toggle");
      if (typeof KTLayoutAsideMenu !== "undefined") KTLayoutAsideMenu.init("kt_aside_menu");
      if (typeof KTLayoutContent !== "undefined") KTLayoutContent.init("kt_content");
      if (typeof KTLayoutFooter !== "undefined") KTLayoutFooter.init("kt_footer");

      // بخش‌های اختیاری
      if (typeof KTLayoutSubheader !== "undefined") KTLayoutSubheader.init("kt_subheader");
      if (typeof KTLayoutScrolltop !== "undefined") KTLayoutScrolltop.init("kt_scrolltop");
      if (typeof KTLayoutStickyCard !== "undefined") KTLayoutStickyCard.init("kt_page_sticky_card");
      if (typeof KTLayoutStretchedCard !== "undefined") KTLayoutStretchedCard.init("kt_page_stretched_card");
      if (typeof KTLayoutQuickActions !== "undefined") KTLayoutQuickActions.init("kt_quick_actions");
      if (typeof KTLayoutQuickPanel !== "undefined") KTLayoutQuickPanel.init("kt_quick_panel");
      if (typeof KTLayoutQuickUser !== "undefined") KTLayoutQuickUser.init("kt_quick_user");
      if (typeof KTLayoutQuickSearch !== "undefined") KTLayoutQuickSearch.init("kt_quick_search");
      if (typeof KTLayoutQuickNotifications !== "undefined") KTLayoutQuickNotifications.init("kt_quick_notifications");
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);
  return <></>;
}
